import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UserService} from '../../../../services/user.service';
import {PricingRulesService} from '../../../../services/pricing-rules.service';
import {RuleDialog} from '../../../../components/price-rules/rule-dialog/rule-dialog.component';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'discounts',
  templateUrl: './discounts.component.html'
})

export class DiscountsComponent implements OnInit {
  @Input() id: any;

  form: FormGroup;
  customerRules: Array<any> = [];
  customer: any;
  userId: any;
  ruleActions: any;
  ruleTypes: any;
  condLogic: any;
  condCompare: any;
  condProp: any;
  condPropVal: any;
  carriers: any;
  progress = true;

  displayedColumns = ['edit', 'name', 'order', 'created_at'];
  constructor(
    private userService: UserService,
    private pricingRulesService: PricingRulesService,
    private _fb: FormBuilder,
    public dialog: MatDialog) {}

  ngOnInit() {
    this.userService.userDetails.subscribe(data => {
      if (data) {
        this.customer = data.id;
      }
    });
    this.userService.userId.subscribe(id => this.userId = id);
    this.form = this._fb.group({
      discount: this._fb.array([
        ['']
      ])
    });

    this.userService.getDiscount().subscribe((discount) => {
      for (const j in discount.general) {
        (this.form.get('discount')as FormArray).push(new FormControl(discount.general[j]));
      }
      this.progress = false;
    });
    this.getCustomerRules();
    this.pricingRulesService.getTypesRules();
    this.pricingRulesService.conditions.subscribe(
      (conditions) => {
        if (conditions) {
          this.ruleActions = conditions.ruleActions;
          this.ruleTypes = conditions.ruleTypes;
          this.condLogic = conditions.condLogic;
          this.condCompare = conditions.condCompare;
          this.condProp = conditions.condProp;
          this.condPropVal = conditions.condPropVal;
          this.carriers = conditions.carriers;
        }
      });
  }

  openRuleDialog(type: string, item: any = '') {
    const dialogRef = this.dialog.open(RuleDialog, {width: '600px'});
    dialogRef.afterClosed().subscribe(result => {
      this.progress = true;
      this.pricingRulesService.getCustomerRules(this.customer).subscribe((data) => {
        this.progress = false;
        if (data.customer) {
          this.customerRules = data.customer;
        } else {
          this.customerRules = [];
        }
      }, (err) => {
        console.log(err);
      });
    });

    const params = {
      type: type,
      pid: this.userId,
      item: item
    };
    const rules = {
      ruleActions: this.ruleActions,
      ruleTypes: this.ruleTypes
    };
    const cond = {
      condLogic: this.condLogic,
      condCompare: this.condCompare,
      condProp: this.condProp,
      condPropVal: this.condPropVal
    };
    dialogRef.componentInstance.rule = params;
    dialogRef.componentInstance.rules = rules;
    dialogRef.componentInstance.cond = cond;
  }
  // discounts
  transferDataSuccess(arr: any, item: any, pos: any) {
    this.changeOrder(arr);
  }
  // discounts
  changeOrder(items: any) {
    const sort = {
      'objects': []
    };
    for (const i in items) {
      items[i]['order'] = i;
      sort['objects'].push({
        'id': items[i]['id'],
        'order': items[i]['order']
      });
    }
  }
  getCustomerRules() {
    this.pricingRulesService.getCustomerRules(this.userId)
      .subscribe((data) => {

        if (data.customer) {
          this.customerRules = data.customer;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/discounts/discounts.component.ts